<script>
import { mapActions, mapState } from 'vuex';
import LogoHeader from '../../components/onboarding/logo-header.vue';

export default {
  name: 'CompanyRole',
  components: {
    LogoHeader,
  },
  data() {
    return {
      role: null,
      otherRole: '',
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.onboarding.isUpdatingOnboarding,
      name: (state) => state.login.name,
      showOnboarding: (state) => state.login.showOnboarding,
    }),
  },
  watch: {
    showOnboarding(newValue) {
      if (!newValue) {
        this.$router.replace({ name: '/' });
      }
    },
  },
  methods: {
    ...mapActions(['setFormValue', 'updateOnboardingStep']),
    async handleContinue() {
      const nextPage = 'match-frequency';
      const response = await this.updateOnboardingStep(nextPage);
      if (!response) {
        // eslint-disable-next-line
        console.error('Error saving data. Please try again.');
        return;
      }
      const roleToUse = this.role === 'other' ? this.otherRole : this.role;
      this.setFormValue({ field: 'role', value: roleToUse });
      this.$router.push({ name: nextPage });
    },
  },
};
</script>

<template>
  <div id="main-container" class="container-fluid">
    <div class="row inner-container">
      <div class="col-6 panel">
        <logo-header />
        <div class="row">
          <div class="my-5 text-center">
            <h3 class="my-4">What’s your role at {{ name || 'this team' }}?</h3>

            <h5 class="text-muted my-5">This will be used to customize your account</h5>

            <b-form-select
              v-model="role"
              size="lg"
              class="mb-4"
              :options="[
                { value: null, text: 'Select your role' },
                { value: 'director-manager', text: 'Director / Manager' },
                { value: 'hrmanager', text: 'HR Manager / People Team' },
                { value: 'executive-assistant', text: 'Executive Assistant' },
                { value: 'csuite-vp', text: 'C-Suite / VP' },
                { value: 'founder-ceo', text: 'Founder / CEO' },
                { value: 'other', text: 'Other' },
              ]"
            ></b-form-select>
            <b-form-input
              v-model="otherRole"
              size="lg"
              placeholder="Please specify"
              class="mb-4"
              v-if="role === 'other'"
            ></b-form-input>

            <b-button block variant="primary" size="lg" @click="handleContinue" :disabled="loading"
              >Continue</b-button
            >
            <div class="mt-5">
              <h1 class="used-by-text">Used by 600+ happy teams!</h1>
              <img
                src="@/assets/team-logos.png"
                alt="Remote Teams"
                fluid
                width="100%"
                class="mt-2"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 panel light-blue">
        <b-progress :value="20" class="progress-container" />

        <div class="text-center mt-5">
          <img src="@/assets/onboarding-2.png" alt="Remote Teams" fluid width="100%" class="mt-5" />
        </div>
        <div class="card mt-5">
          <div class="card-body">✅ Organize team 1-1's automatically</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#main-container .inner-container {
  min-height: 100vh;
}

.inner-container .panel {
  padding: 70px;
}

.inner-container .light-blue {
  background-color: #f4f7fc;
}

.used-by-text {
  color: #222e3f;
  font-weight: 600;
  line-height: 140%;
  font-size: 34px;
  font-style: italic;
}
</style>
